import { Skeleton, Stack } from "@mui/material";

const WidgetPreviewCardSkeleton = () => {
  return (
    <Stack spacing={2}>
      <Skeleton variant="rounded" width="70%" height="0.5rem" />
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Skeleton variant="rounded" width="30%" height="0.5rem" />
        <Skeleton variant="rounded" width="25%" height="0.5rem" />
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Skeleton variant="rounded" width="40%" height="0.5rem" />
        <Skeleton variant="rounded" width="30%" height="0.5rem" />
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Skeleton variant="rounded" width="40%" height="0.5rem" />
        <Skeleton variant="rounded" width="30%" height="0.5rem" />
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Skeleton variant="rounded" width="30%" height="0.5rem" />
        <Skeleton variant="rounded" width="25%" height="0.5rem" />
      </Stack>
    </Stack>
  );
};

export default WidgetPreviewCardSkeleton;
